import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { pickLang } from "./strings";

const LanguageContext = createContext({ lang: "it", t: pickLang("it"), setLang: () => {} });

function detectInitialLang() {
  try {
    const stored = window.localStorage.getItem("ac_lang");
    if (stored === "it" || stored === "en") return stored;
    const nav = (navigator.language || "it").toLowerCase();
    if (nav.startsWith("it")) return "it";
    return "en";
  } catch (_) {
    return "it";
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);

  useEffect(() => {
    try { window.localStorage.setItem("ac_lang", lang); } catch (_) {}
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((next) => setLangState(next === "en" ? "en" : "it"), []);
  const toggle = useCallback(() => setLangState((l) => (l === "it" ? "en" : "it")), []);

  const value = { lang, t: pickLang(lang), setLang, toggle };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
